import { Component } from '@angular/core';
import { MaterialModule } from '../../../material/material.module';
import { CommonModule } from '@angular/common';
import { PipesModule } from '../../../pipes/pipes.module';

@Component({
  selector: 'app-middle-banner',
  standalone: true,
  imports: [MaterialModule, CommonModule, PipesModule],
  templateUrl: './middle-banner.component.html',
  styleUrl: './middle-banner.component.scss'
})
export class MiddleBannerComponent {


	joinNow(){

	}
}
